export const getInitials = (name: string, isOnlyName?: boolean) => {
    const initials = name.split(' ');

    if (isOnlyName) {
        return initials[0].substring(0, 1);
    }

    return initials.length >= 2
        ? (initials[0].substring(0, 1) + initials[1].substring(0, 1)).toUpperCase()
        : initials[0].substring(0, 1);
};
